__turbopack_context__.v({
  "container": "stickyFooter-module-scss-module__FhgoJG__container",
  "content": "stickyFooter-module-scss-module__FhgoJG__content",
  "isSmall": "stickyFooter-module-scss-module__FhgoJG__isSmall",
  "pageContainerWithStickyFooter": "stickyFooter-module-scss-module__FhgoJG__pageContainerWithStickyFooter",
  "row": "stickyFooter-module-scss-module__FhgoJG__row",
});
